import { createFeatureSelector, createSelector } from '@ngrx/store';

import { SEARCH_SETTINGS_FEATURE_KEY, SearchSettingsState } from './search-settings.reducer';

export const getSearchSettingsState = createFeatureSelector<SearchSettingsState>(
  SEARCH_SETTINGS_FEATURE_KEY,
);

export const getSearchSettings = createSelector(
  getSearchSettingsState,
  (state: SearchSettingsState) => state.searchSettings,
);

export const getSearchMenuSettings = createSelector(
  getSearchSettingsState,
  (state: SearchSettingsState) => state.menuSettings,
);

export const isSearchSettingsLoaded = createSelector(
  getSearchSettingsState,
  (state: SearchSettingsState) => state.loaded,
);
